export const USER_STEPS_STRINGS = {
  'next_unit_banner.title': 'Let’s talk about your next unit',
};
